import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ErrorPage = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center text-center px-4 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-dark-lighter to-black pointer-events-none z-0" />
      <div className="relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4">
            Oops!
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Something went wrong on our end. Please try again later.
          </p>
          <Link
            to="/"
            className="inline-block bg-primary text-white font-bold py-3 px-8 rounded-lg hover:bg-primary-dark transition-colors duration-300"
          >
            Go to Homepage
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default ErrorPage; 